import type { ReactNode } from 'react';

interface PageShellProps {
  title: string;
  description: string;
  children?: ReactNode;
}

export function PageShell({ title, description, children }: PageShellProps) {
  return (
    <main className="min-h-screen bg-slate-50 px-6 py-8 text-slate-900">
      <section className="mx-auto flex w-full max-w-4xl flex-col gap-6 rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <header className="space-y-2">
          <p className="text-sm font-medium uppercase tracking-[0.24em] text-sky-600">
            single-pages
          </p>
          <h1 className="text-2xl font-semibold">{title}</h1>
          <p className="text-sm leading-6 text-slate-600">{description}</p>
        </header>
        {children ? <div className="space-y-4">{children}</div> : null}
      </section>
    </main>
  );
}
